import React from 'react'
import { useTranslation } from 'react-i18next'

import type { ChainingModal } from 'features/Ticket'
import ModalSuccess from './ModalSuccess'

import { ModalConfirm } from './ModalConfirm'

import { TICKET_ACTION } from 'helpers/constants'

type Props = {
  type: string
  isChainingModal: ChainingModal
  isLoading: boolean
  callApiForCloseTask: () => void
  handleCloseConfirmModal: () => void
  handleRejectCloseModal: () => void
  handleSubmitCloseModal: () => void
  handleCloseSuccessModal: () => void
}

export const ModalChainTicketDetail: React.FC<Props> = (props) => {
  const {
    isChainingModal: { openCancel, openConfirm, openSuccess },
    isLoading,
    callApiForCloseTask,
    handleCloseConfirmModal,
    handleRejectCloseModal,
    handleSubmitCloseModal,
    handleCloseSuccessModal,
    type = '',
  } = props

  const {
    REQUEST_CLOSE_TICKET,
    TICKET_ASSIGN,
    TICKET_TRANSFER,
    PENDING_TICKET,
  } = TICKET_ACTION

  const { t } = useTranslation(['layout', 'ticket', 'common'])

  const handleCancelModalLabel = () => {
    switch (type) {
      case REQUEST_CLOSE_TICKET:
        return {
          title: t('ticket:modalCancel.title'),
          decs: t('ticket:modalCancel.description'),
          confirm: t('ticket:modalCancel.submit.button'),
          cancel: t('ticket:modalCancel.cancel.button'),
        }

      case PENDING_TICKET:
        return {
          title: t('ticket:modalCancel.pending.title'),
          decs: t('ticket:modalCancel.pending.description'),
          confirm: t('ticket:modalCancel.submit.button'),
          cancel: t('ticket:modalCancel.cancel.button'),
        }

      case TICKET_ASSIGN:
        return {
          title: t('ticket:modalCancel.assign.title'),
          decs: t('ticket:modalCancel.assign.description'),
          confirm: t('ticket:modalCancel.submit.button'),
          cancel: t('ticket:modalCancel.cancel.button'),
        }

      case TICKET_TRANSFER:
        return {
          title: t('ticket:modalCancel.transfer.title'),
          decs: t('ticket:modalCancel.transfer.description'),
          confirm: t('ticket:modalCancel.submit.button'),
          cancel: t('ticket:modalCancel.cancel.button'),
        }

      default:
        return { title: '', decs: '', confirm: '', cancel: '' }
    }
  }

  const handleConfirmModalLabel = () => {
    switch (type) {
      case REQUEST_CLOSE_TICKET:
        return {
          title: t('ticket:modalConfirm.title'),
          decs: t('ticket:modalConfirm.description'),
          confirm: t('common:submit.button'),
        }

      case PENDING_TICKET:
        return {
          title: t('ticket:modalConfirm.pending.title'),
          decs: t('ticket:modalConfirm.pending.description'),
          confirm: t('common:submit.button'),
        }

      case TICKET_ASSIGN:
        return {
          title: t('ticket:modalConfirm.assign.title'),
          decs: t('ticket:modalConfirm.assign.description'),
          confirm: t('common:submit.button'),
        }

      case TICKET_TRANSFER:
        return {
          title: t('ticket:modalConfirm.transfer.title'),
          decs: t('ticket:modalConfirm.transfer.description'),
          confirm: t('common:submit.button'),
        }

      default:
        return { title: '', decs: '', confirm: '' }
    }
  }

  const handleSuccessModalLabel = () => {
    switch (type) {
      case REQUEST_CLOSE_TICKET:
        return t('common:success.label')

      case PENDING_TICKET:
        return t('ticket:modalSuccess.pending')

      case TICKET_ASSIGN:
        return t('ticket:modalSuccess.assign')

      case TICKET_TRANSFER:
        return t('ticket:modalSuccess.transfer')

      default:
        return ''
    }
  }

  const {
    title: titleModalConfirm,
    decs: decsModalConfirm,
    confirm: confirmModalConfirm,
  } = handleConfirmModalLabel()

  const {
    title: titleModalCancel,
    decs: decsModalCancel,
    confirm: confirmModalCancel,
    cancel: textBtnModalCancel,
  } = handleCancelModalLabel()

  return (
    <>
      {openSuccess && (
        <ModalSuccess
          isOpen={openSuccess}
          description={handleSuccessModalLabel()}
          onClose={handleCloseSuccessModal}
        />
      )}

      {openConfirm && (
        <ModalConfirm
          isOpen={openConfirm}
          title={titleModalConfirm}
          decs={decsModalConfirm}
          textBtnConfirm={confirmModalConfirm}
          isLoading={isLoading}
          onConfirm={callApiForCloseTask}
          onClose={handleCloseConfirmModal}
        />
      )}

      {openCancel && (
        <ModalConfirm
          isOpen={openCancel}
          title={titleModalCancel}
          decs={decsModalCancel}
          textBtnConfirm={confirmModalCancel}
          textBtnCancel={textBtnModalCancel}
          onConfirm={handleSubmitCloseModal}
          onClose={handleRejectCloseModal}
        />
      )}
    </>
  )
}
